import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class Homebutton extends Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <div className="homebutton">
        <Link className="ion-md-home" to={"/" + this.props.lang + "/home/" + this.props.token}> </Link>
      </div>
    )
  }
}
export default Homebutton;


// WEBPACK FOOTER //
// ./src/components/Homebutton.js